import React from "react";
import logo from "../../assets/images/mmt/auth-inochi-icon.png";
import { useSection } from "../../i18n/useSection";

export default function AuthHero() {
  const t = useSection("mmtAuth");

  return (
    <header className="mmt-auth-hero">
      <div className="mmt-auth-brand">
        <img src={logo} alt="" />
        <span>SeniorLife.AI</span>
      </div>
      <div className="mmt-auth-titles">
        <h1 className="mmt-auth-headline">{t.headline}</h1>
        <p className="mmt-auth-tagline">{t.tagline}</p>
        <p className="mmt-auth-wellness">{t.wellness}</p>
      </div>
    </header>
  );
}
